<template>
  <v-hover v-slot:default="{ hover }" :disabled="disabled">
    <div>
      <v-card
        flat
        height="175"
        width="175"
        :class="[
          'rounded-10',
          'blue-border',
          { 'btn-primary': hover, 'disabled-button': disabled }
        ]"
        @click="$emit('chooseOrder', 'IMMEDIATE-CASE')"
      >
        <v-card-text
          class="px-1 text-center text-subtitle-1 pb-0"
          :style="{
            color: hover ? 'white' : '#147BD1'
          }"
        >
          <strong> IMMEDIATE DESIGN ONLY </strong>
        </v-card-text>
        <v-container fluid>
          <v-img
            contain
            :src="require('@/assets/immediate-design-only.png')"
            position="center center"
          />
        </v-container>
      </v-card>
    </div>
  </v-hover>
</template>

<script>
export default {
  name: "ImmediateDesignButton",

  props: ["disabled"]
}
</script>

<style scoped>
.disabled-button {
  cursor: not-allowed;
  pointer-events: none;
  filter: grayscale(10%) brightness(80%);
  opacity: 0.5;
}
</style>
